<template>
    <relatorio-page :titulo=" 'Relatório Acompanhamento de Doações - ' + filtro.ano " :cabecalhoCompleto="true" :exportarExcel="false" :paisagem="true" :fonteVariavel="true">

        <v-row v-if="itens.length > 1">
            <v-col cols="12">
                <v-simple-table id="tabela" dense class="py-2 text-caption">
                    <template v-slot: default>
                        <thead class="fonte" style="background-color: #4A70A8">
                            <tr>
                                <th class="text-left" style="font-size: 100% ; color: white">Doador</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Jan</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Fev</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Mar</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Abr</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Mai</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Jun</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Jul</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Ago</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Set</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Out</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Nov</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Dez</th>
                                <th class="text-center fonte" style="font-size: 100% ; color: white">Total</th>
                                <th class="text-right fonte" style="font-size: 100% ; color: white">Proposto</th>
                            </tr>
                        </thead>
                        <tbody class="fonte">
                            <tr v-for="(item, index) in itens" :key="index" :style=" index == itens.length - 1 ? 'background-color: #4A70A8' : index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                <td class="text-left"   :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.doador}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.janeiro? item.janeiro.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.fevereiro ? item.fevereiro.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.marco ? item.marco.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.abril ? item.abril.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.maio ? item.maio.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.junho ? item.junho.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.julho ? item.julho.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.agosto ? item.agosto.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.setembro ? item.setembro.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.outubro ? item.outubro.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.novembro ? item.novembro.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.dezembro ? item.dezembro.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.total ? item.total.toMoeda() : '-'}}</td>
                                <td class="text-center" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.totalProposto ? item.totalProposto.toMoeda() : '-'}}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>                
            </v-col>
        </v-row>

        <v-row v-else>
            <v-col cols="12">
                Nenhum Registro Encontrado
            </v-col>
        </v-row>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </relatorio-page>
</template>

<script>
import RecebivelService from '../../../core/services/financeiro/RecebivelService';
export default {
    
    data: () => ({
        itens:{
            required: true
        },
        filtro:{
            required: true
        },
        overlay: false
    }),
    props:{

    },
    mounted(){
        this.filtro = this.$route.query;
        this.Carregar();
    },
    methods:{
        Carregar(){
            const service = new RecebivelService();
            this.overlay = true;
            service.AcompanhamentoDoacao(this.filtro).then(
                res=>{
                    this.itens = res.data;
                },
                err=>{
                    this.$swal('Aviso', err.response.data, 'error')
                }
            ).finally(() => {
                this.overlay = false;
            })
        }
    }   

}
</script>

<style>

.fonte{
  font-size: 80%;
}

</style>
